var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loading',{attrs:{"loading":_vm.loading}}),_vm._l((_vm.appointments),function(appointment,index){return _c('AppointmentCard',{key:index,attrs:{"appointment":appointment}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }